import React from "react";
import { Layout } from "../../layouts/Layout";
import { BlogPageWrapper } from "../../components/BlogAreas/BlogPageWrapper";
import { useLocation, useSearchParams } from "react-router-dom";
import { LocaleLink } from "../../i18n/LocaleLink";
import {
  BLOG_01_IMG_02_857X480,
  BLOG_01_IMG_03_857X480,
  BLOG_01_IMG_04_857X480,
  BLOG_01_MAIN_IMAGE_857X480,
  BLOG_AVATAR01,
  CHECK_ICON,
} from "../../lib/assets";
import { blogDetailsPath, getBlogById } from "../../data/blogs";
import { useTranslation } from "react-i18next";

const BlogDetailsPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const blogId = searchParams.get("blogId") ?? location.state?.blogId;
  const blog = getBlogById(t, blogId);

  if (!blog) {
    return (
      <Layout breadcrumb={t("pages.blogNotFound.breadcrumb")} title={t("pages.blogNotFound.title")}>
        <BlogPageWrapper blogId={blogId}>
          <div className="blog-details-wrap">
            <div className="blog-details-content">
              <h2 className="title">{t("blogDetails.notFoundTitle")}</h2>
              <p>{t("blogDetails.notFoundText")}</p>
            </div>
          </div>
        </BlogPageWrapper>
      </Layout>
    );
  }

  return (
    <Layout breadcrumb={t("pages.blogDetails.breadcrumb")} title={t("pages.blogDetails.title")}>
      <BlogPageWrapper>
        {/* image */}
        <div className="blog-details-thumb">
          <img src={blog.content.mainImage} alt="" />
        </div>

        {/* content */}
        <div className="blog-details-content">
          <h2 className="title">{blog.content.title}</h2>

          <div className="blog-meta-three">
            <ul className="list-wrap">
              <li>
                <i className="far fa-calendar"></i>{blog.createdAt}
              </li>
              <li>
                <img src={BLOG_AVATAR01} alt="" />
                {t("blogDetails.by")}{" "}
                <LocaleLink to={blogDetailsPath(blog.id)}>{blog.author}</LocaleLink>
              </li>
              <li>
                <i className="fas fa-tags"></i>
                <LocaleLink to="/blog">{blog.tag}</LocaleLink>
              </li>
              {/* <li>
                <i className="flaticon-speech-bubble"></i>
                <LocaleLink to="/blog-details">05 Comments</LocaleLink>
              </li> */}
            </ul>
          </div>

          <p>
            {blog.content.paragraphs[0]}
          </p>
          <h4 className="title-two">{blog.content.subtitles[0]}</h4>
          <p>
            {blog.content.paragraphs[1]}
          </p>
          <blockquote>
            <p>
              {blog.content.quote}
            </p>
          </blockquote>
          <p>
            {blog.content.paragraphs[2]}
          </p>
          <div className="blog-details-thumb">
            <img src={blog.content.images[0]} alt="" />
          </div>
          <h4 className="title-two">{blog.content.subtitles[1]}</h4>
          <p>
            {blog.content.paragraphs[3]}
          </p>
          <div className="bd-inner-wrap">
            <div className="row align-items-center">
              <div className="col-45">
                <div className="content">
                  <ul className="list-wrap">
                    {blog.content.todoList.map((item, index) => (
                      <li key={index}>
                      <img src={CHECK_ICON} alt="" />
                      {item}
                    </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="blog-details-thumb">
            <img src={blog.content.images[1]} alt="" />
          </div>
          {/* <div className="bd-inner-wrap">
            <div className="row align-items-center">
              <div className="col-46">
                <div className="thumb">
                  <img src={BLOG_DETAILS02} alt="" />

                  <VideoPlayerOne
                    src={"https://www.youtube.com/watch?v=6mkoGSqTqFI"}
                  />
                </div>
              </div>

              <div className="col-54">
                <div className="content">
                  <h3 className="title-two">
                    Conduct replied off whether arrived adapted
                  </h3>
                  <p>
                    when an unknown printer took a galley type remaining
                    essentially unchan galley of type and scrambled it to make a
                    type specimen book.
                  </p>
                  <ul className="list-wrap">
                    <li>
                      <img src={CHECK_ICON} alt="" />
                      Commercial Property Insurance
                    </li>
                    <li>
                      <img src={CHECK_ICON} alt="" />
                      Budget Friendly Theme
                    </li>
                    <li>
                      <img src={CHECK_ICON} alt="" />
                      Happy Customers
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div> */}
          <h4 className="title-two">{blog.content.subtitles[2]}</h4>
          <p>
            {blog.content.paragraphs[4]}
          </p>
          <p>
            {blog.content.paragraphs[5]}
          </p>
          <div className="blog-details-thumb">
            <img src={blog.content.images[2]} alt="" />
          </div>
          <h4 className="title-two">{blog.content.subtitles[3]}</h4>
          <p>
            {blog.content.paragraphs[6]}
          </p>
          <p>{t("blogDetails.ctaImport")}</p>
          <div className="bd-content-bottom">
            <div className="row align-items-center">
              <div className="col-md-7">
                <div className="post-tags">
                  <h5 className="title">{t("blogDetails.tags")}</h5>
                  <ul className="list-wrap">
                    {blog.content.tags.map((tag) => (
                      <li key={tag}>
                        <a href="#">{tag}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* bottom */}
              <div className="col-md-5">
                <div className="blog-post-share">
                  <h5 className="title">{t("blogDetails.share")}</h5>
                  <ul className="list-wrap">
                    <li>
                      <a href="#">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-pinterest-p"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BlogPageWrapper>
    </Layout>
  );
};

export default BlogDetailsPage;
